export class CreateDevOpsActionResponse {
    eventRuleId?: string;
    error?: string;
}